import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=76211ec6&scoped=true"
import script from "./NewDashboard.vue?vue&type=script&lang=js"
export * from "./NewDashboard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./NewDashboard.vue?vue&type=style&index=0&id=76211ec6&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "76211ec6",
  null
  ,true
)

export default component.exports